import { render, staticRenderFns } from "./SuspendedTraffic.vue?vue&type=template&id=11f00725&scoped=true&"
import script from "./SuspendedTraffic.vue?vue&type=script&lang=js&"
export * from "./SuspendedTraffic.vue?vue&type=script&lang=js&"
import style0 from "./SuspendedTraffic.vue?vue&type=style&index=0&id=11f00725&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f00725",
  null
  
)

export default component.exports